// extracted by mini-css-extract-plugin
module.exports = {"filtersLayout":"Layout_filtersLayout__8EF_6","filtersContainer":"Layout_filtersContainer__j19qC","resultsLayout":"Layout_resultsLayout__QR7x3"};